function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1932(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 29.2,
    height: 18.87,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.9931578947368421
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 9.435,
    fontFamily: "Arial"
  }, "\n        Charles_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18.87,
    width: 29.2,
    height: 22.87,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5246666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 30.305,
    fontFamily: "Arial"
  }, "\n        New_Kent_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 41.74,
    width: 29.2,
    height: 23.94,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.408235294117647
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 53.71,
    fontFamily: "Arial"
  }, "\n        James_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 65.68,
    width: 29.2,
    height: 24.67,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.541875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 78.01500000000001,
    fontFamily: "Arial"
  }, "\n        Buena_Vista_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 90.35,
    width: 29.2,
    height: 28.45,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.673529411764706
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 104.57499999999999,
    fontFamily: "Arial"
  }, "\n        Williamsburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 118.8,
    width: 29.2,
    height: 29.52,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.433333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 133.56,
    fontFamily: "Arial"
  }, "\n        Essex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 148.31,
    width: 29.2,
    height: 30.14,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.3904761904761904
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 163.38,
    fontFamily: "Arial"
  }, "\n        King_and_Queen_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 178.45,
    width: 29.2,
    height: 31.26,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9466666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 194.07999999999998,
    fontFamily: "Arial"
  }, "\n        Powhatan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 209.71,
    width: 29.2,
    height: 34.25,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.7176470588235293
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 226.835,
    fontFamily: "Arial"
  }, "\n        Cumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 243.96,
    width: 29.2,
    height: 36.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.246153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 262.325,
    fontFamily: "Arial"
  }, "\n        Greene_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 280.69,
    width: 29.2,
    height: 37.12,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9466666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 299.25,
    fontFamily: "Arial"
  }, "\n        Richmond_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 317.81,
    width: 29.2,
    height: 38.42,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6222222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 337.02,
    fontFamily: "Arial"
  }, "\n        King_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 356.22,
    width: 29.2,
    height: 40.5,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.46
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 376.47,
    fontFamily: "Arial"
  }, "\n        Prince_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 396.72,
    width: 29.2,
    height: 40.56,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5368421052631578
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 417,
    fontFamily: "Arial"
  }, "\n        Rappahannock_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 437.28,
    width: 29.2,
    height: 41.46,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.433333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 458.01,
    fontFamily: "Arial"
  }, "\n        Surry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 478.74,
    width: 29.2,
    height: 41.8,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 499.64,
    fontFamily: "Arial"
  }, "\n        Middlesex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 520.54,
    width: 29.2,
    height: 43.26,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9466666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 542.17,
    fontFamily: "Arial"
  }, "\n        Fluvanna_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 563.8,
    width: 29.2,
    height: 45.29,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5368421052631578
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 586.4449999999999,
    fontFamily: "Arial"
  }, "\n        King_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 609.09,
    width: 29.2,
    height: 45.29,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6545454545454543
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 631.735,
    fontFamily: "Arial"
  }, "\n        York_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 654.37,
    width: 29.2,
    height: 45.63,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.6,
    y: 677.1850000000001,
    fontFamily: "Arial"
  }, "\n        Goochland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 0,
    width: 34.1,
    height: 39.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8944444444444446
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.25,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Greensville_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.3,
    y: 0,
    width: 34.69,
    height: 39.11,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.668461538461538
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 80.645,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Sussex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.99,
    y: 0,
    width: 35.24,
    height: 39.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.3493333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 115.61,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Highland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.23,
    y: 0,
    width: 35.91,
    height: 39.11,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.762307692307692
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 151.185,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Amelia_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 169.13,
    y: 0,
    width: 36.04,
    height: 39.11,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8968421052631579
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.15,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Westmoreland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.17,
    y: 0,
    width: 37.17,
    height: 39.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.77
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.755,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Northumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.34,
    y: 0,
    width: 37.84,
    height: 39.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7028571428571433
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.26,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Warwick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.19,
    y: 0,
    width: 38.22,
    height: 39.11,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.185
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 299.3,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Radford_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 318.41,
    y: 0,
    width: 38.98,
    height: 39.11,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.43625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 337.90000000000003,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Lancaster_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.39,
    y: 0,
    width: 39.74,
    height: 39.11,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1727777777777777
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.26,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        South_Norfolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.12,
    y: 0,
    width: 40.28,
    height: 39.11,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.300588235294118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 417.26,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Martinsville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 437.41,
    y: 0,
    width: 40.62,
    height: 39.11,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2591666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 457.72,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Craig_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478.02,
    y: 0,
    width: 40.91,
    height: 39.11,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0084615384615385
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 498.47499999999997,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Clarke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 518.94,
    y: 0,
    width: 41.71,
    height: 39.11,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.555454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.7950000000001,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Bath_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.65,
    y: 0,
    width: 45.58,
    height: 39.11,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2591666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 583.4399999999999,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Hampton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 606.23,
    y: 0,
    width: 45.83,
    height: 39.11,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.300588235294118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 629.145,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Buckingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 652.06,
    y: 0,
    width: 47.94,
    height: 39.11,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.444375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.03,
    y: 19.555,
    fontFamily: "Arial"
  }, "\n        Dinwiddie_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 39.11,
    width: 46.78,
    height: 40.33,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1226315789473684
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 59.275,
    fontFamily: "Arial"
  }, "\n        Spotsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 79.44,
    width: 46.78,
    height: 40.57,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.8978571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 99.725,
    fontFamily: "Arial"
  }, "\n        Mathews_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 120.01,
    width: 46.78,
    height: 41.87,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.791333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 140.945,
    fontFamily: "Arial"
  }, "\n        Stafford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 161.89,
    width: 46.78,
    height: 41.87,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2036842105263155
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 182.825,
    fontFamily: "Arial"
  }, "\n        Fredericksburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 203.76,
    width: 46.78,
    height: 42.09,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1045000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 224.805,
    fontFamily: "Arial"
  }, "\n        Prince_Edward_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 245.85,
    width: 46.78,
    height: 42.58,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.504705882352941
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 267.14,
    fontFamily: "Arial"
  }, "\n        Gloucester_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 288.43,
    width: 46.78,
    height: 43.84,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 310.35,
    fontFamily: "Arial"
  }, "\n        Lunenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 332.27,
    width: 46.78,
    height: 44.69,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.4827777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 354.615,
    fontFamily: "Arial"
  }, "\n        Clifton_Forge_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 376.96,
    width: 46.78,
    height: 44.83,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 399.375,
    fontFamily: "Arial"
  }, "\n        Isle_of_Wight_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 421.79,
    width: 46.78,
    height: 45.04,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4646153846153847
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 444.31,
    fontFamily: "Arial"
  }, "\n        Louisa_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 466.82,
    width: 46.78,
    height: 45.25,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7708333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 489.445,
    fontFamily: "Arial"
  }, "\n        Suffolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 512.07,
    width: 46.78,
    height: 46.41,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 535.2750000000001,
    fontFamily: "Arial"
  }, "\n        Hopewell_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 558.48,
    width: 46.78,
    height: 46.83,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3414285714285716
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 581.895,
    fontFamily: "Arial"
  }, "\n        Hanover_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 605.32,
    width: 46.78,
    height: 47.01,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.751764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 628.825,
    fontFamily: "Arial"
  }, "\n        Appomattox_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.2,
    y: 652.32,
    width: 46.78,
    height: 47.68,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8983333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.59,
    y: 676.1600000000001,
    fontFamily: "Arial"
  }, "\n        Bland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.97,
    y: 39.11,
    width: 47.49,
    height: 47.24,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1493333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 99.715,
    y: 62.730000000000004,
    fontFamily: "Arial"
  }, "\n        Caroline_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.46,
    y: 39.11,
    width: 48.04,
    height: 47.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.3742857142857146
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 147.48,
    y: 62.730000000000004,
    fontFamily: "Arial"
  }, "\n        Madison_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.5,
    y: 39.11,
    width: 49.57,
    height: 47.24,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 196.285,
    y: 62.730000000000004,
    fontFamily: "Arial"
  }, "\n        Brunswick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 221.07,
    y: 39.11,
    width: 51.04,
    height: 47.24,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 246.59,
    y: 62.730000000000004,
    fontFamily: "Arial"
  }, "\n        Nansemond_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 272.11,
    y: 39.11,
    width: 51.25,
    height: 47.24,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.633846153846154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.735,
    y: 62.730000000000004,
    fontFamily: "Arial"
  }, "\n        Warren_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 323.36,
    y: 39.11,
    width: 51.42,
    height: 47.24,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 349.07,
    y: 62.730000000000004,
    fontFamily: "Arial"
  }, "\n        Charlotte_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 374.77,
    y: 39.11,
    width: 52.32,
    height: 47.24,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.936666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 400.93,
    y: 62.730000000000004,
    fontFamily: "Arial"
  }, "\n        Henry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 427.1,
    y: 39.11,
    width: 54.13,
    height: 47.24,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.633846153846154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 454.165,
    y: 62.730000000000004,
    fontFamily: "Arial"
  }, "\n        Staunton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 481.23,
    y: 39.11,
    width: 54.2,
    height: 47.24,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6244444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 508.33000000000004,
    y: 62.730000000000004,
    fontFamily: "Arial"
  }, "\n        Southampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 535.44,
    y: 39.11,
    width: 54.55,
    height: 47.24,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.633846153846154
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 562.715,
    y: 62.730000000000004,
    fontFamily: "Arial"
  }, "\n        Orange_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 589.99,
    y: 39.11,
    width: 54.9,
    height: 47.24,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6244444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 617.44,
    y: 62.730000000000004,
    fontFamily: "Arial"
  }, "\n        Northampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 644.89,
    y: 39.11,
    width: 55.11,
    height: 47.24,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.936666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.4449999999999,
    y: 62.730000000000004,
    fontFamily: "Arial"
  }, "\n        Bristol_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.97,
    y: 86.35,
    width: 53.16,
    height: 51.7,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4466666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.55,
    y: 112.19999999999999,
    fontFamily: "Arial"
  }, "\n        Nottoway_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.97,
    y: 138.05,
    width: 53.16,
    height: 52.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0794117647058825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.55,
    y: 164.22500000000002,
    fontFamily: "Arial"
  }, "\n        Harrisonburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.97,
    y: 190.4,
    width: 53.16,
    height: 52.66,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.05076923076923
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.55,
    y: 216.73000000000002,
    fontFamily: "Arial"
  }, "\n        Nelson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.97,
    y: 243.06,
    width: 53.16,
    height: 52.72,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.55,
    y: 269.42,
    fontFamily: "Arial"
  }, "\n        Charlottesville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.97,
    y: 295.78,
    width: 53.16,
    height: 54.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.43
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.55,
    y: 322.885,
    fontFamily: "Arial"
  }, "\n        Floyd_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.97,
    y: 349.99,
    width: 53.16,
    height: 55.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5439999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.55,
    y: 377.555,
    fontFamily: "Arial"
  }, "\n        Culpeper_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.97,
    y: 405.12,
    width: 53.16,
    height: 57.33,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7971428571428567
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.55,
    y: 433.785,
    fontFamily: "Arial"
  }, "\n        Patrick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.97,
    y: 462.45,
    width: 53.16,
    height: 58.85,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.658
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.55,
    y: 491.875,
    fontFamily: "Arial"
  }, "\n        Princess_Anne_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.97,
    y: 521.3,
    width: 53.16,
    height: 59,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.531428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.55,
    y: 550.8,
    fontFamily: "Arial"
  }, "\n        Prince_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.97,
    y: 580.3,
    width: 53.16,
    height: 59.09,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5439999999999996
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.55,
    y: 609.8449999999999,
    fontFamily: "Arial"
  }, "\n        Winchester_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.97,
    y: 639.39,
    width: 53.16,
    height: 60.61,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.531428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.55,
    y: 669.6949999999999,
    fontFamily: "Arial"
  }, "\n        Elizabeth_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.13,
    y: 86.35,
    width: 55.57,
    height: 58.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9692857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 156.915,
    y: 115.64999999999999,
    fontFamily: "Arial"
  }, "\n        Amherst_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.7,
    y: 86.35,
    width: 56.58,
    height: 58.6,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.53625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 212.98999999999998,
    y: 115.64999999999999,
    fontFamily: "Arial"
  }, "\n        Frederick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 241.27,
    y: 86.35,
    width: 56.72,
    height: 58.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7813333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 269.63,
    y: 115.64999999999999,
    fontFamily: "Arial"
  }, "\n        Campbell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 297.99,
    y: 86.35,
    width: 59.02,
    height: 58.6,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9066666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.5,
    y: 115.64999999999999,
    fontFamily: "Arial"
  }, "\n        Buchanan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 357.01,
    y: 86.35,
    width: 67.24,
    height: 58.6,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9066666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 390.63,
    y: 115.64999999999999,
    fontFamily: "Arial"
  }, "\n        Fauquier_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 424.25,
    y: 86.35,
    width: 67.83,
    height: 58.6,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 458.165,
    y: 115.64999999999999,
    fontFamily: "Arial"
  }, "\n        Alleghany_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 492.08,
    y: 86.35,
    width: 68.48,
    height: 58.6,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9066666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 526.3199999999999,
    y: 115.64999999999999,
    fontFamily: "Arial"
  }, "\n        Petersburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 560.55,
    y: 86.35,
    width: 69.54,
    height: 58.6,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.2555555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 595.3199999999999,
    y: 115.64999999999999,
    fontFamily: "Arial"
  }, "\n        Mecklenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.09,
    y: 86.35,
    width: 69.91,
    height: 58.6,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.0450000000001,
    y: 115.64999999999999,
    fontFamily: "Arial"
  }, "\n        Albemarle_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.13,
    y: 144.96,
    width: 68.48,
    height: 62.9,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6999999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.37,
    y: 176.41,
    fontFamily: "Arial"
  }, "\n        Rockbridge_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.13,
    y: 207.85,
    width: 68.48,
    height: 64.79,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.41
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.37,
    y: 240.245,
    fontFamily: "Arial"
  }, "\n        Chesterfield_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.13,
    y: 272.65,
    width: 68.48,
    height: 67.29,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.607500000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.37,
    y: 306.29499999999996,
    fontFamily: "Arial"
  }, "\n        Giles_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.13,
    y: 339.94,
    width: 68.48,
    height: 67.99,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.856428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.37,
    y: 373.935,
    fontFamily: "Arial"
  }, "\n        Bedford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.13,
    y: 407.92,
    width: 68.48,
    height: 72.21,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.565333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.37,
    y: 444.02500000000003,
    fontFamily: "Arial"
  }, "\n        Accomack_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.13,
    y: 480.14,
    width: 68.48,
    height: 72.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.8914285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.37,
    y: 516.475,
    fontFamily: "Arial"
  }, "\n        Carroll_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.13,
    y: 552.81,
    width: 68.48,
    height: 73.44,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.37,
    y: 589.53,
    fontFamily: "Arial"
  }, "\n        Botetourt_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 129.13,
    y: 626.25,
    width: 68.48,
    height: 73.75,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.8914285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.37,
    y: 663.125,
    fontFamily: "Arial"
  }, "\n        Loudoun_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.61,
    y: 144.96,
    width: 65.78,
    height: 76.94,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.3853333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.5,
    y: 183.43,
    fontFamily: "Arial"
  }, "\n        Franklin_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.39,
    y: 144.96,
    width: 65.92,
    height: 76.94,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.070769230769231
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 296.34999999999997,
    y: 183.43,
    fontFamily: "Arial"
  }, "\n        Danville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.31,
    y: 144.96,
    width: 67.51,
    height: 76.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.137272727272728
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 363.065,
    y: 183.43,
    fontFamily: "Arial"
  }, "\n        Page_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.82,
    y: 144.96,
    width: 72.79,
    height: 76.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.281764705882353
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 433.215,
    y: 183.43,
    fontFamily: "Arial"
  }, "\n        Montgomery_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 469.6,
    y: 144.96,
    width: 73.83,
    height: 76.94,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.273571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 506.51500000000004,
    y: 183.43,
    fontFamily: "Arial"
  }, "\n        Pulaski_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.44,
    y: 144.96,
    width: 74.48,
    height: 76.94,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.206666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.6800000000001,
    y: 183.43,
    fontFamily: "Arial"
  }, "\n        Wythe_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 617.91,
    y: 144.96,
    width: 82.09,
    height: 76.94,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.049473684210526
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.9549999999999,
    y: 183.43,
    fontFamily: "Arial"
  }, "\n        Pittsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.61,
    y: 221.89,
    width: 80.88,
    height: 78.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.509166666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.05,
    y: 260.945,
    fontFamily: "Arial"
  }, "\n        Scott_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.61,
    y: 300,
    width: 80.88,
    height: 78.8,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.628571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.05,
    y: 339.4,
    fontFamily: "Arial"
  }, "\n        Henrico_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.61,
    y: 378.79,
    width: 80.88,
    height: 78.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.92875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.05,
    y: 418.22,
    fontFamily: "Arial"
  }, "\n        Dickenson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.61,
    y: 457.65,
    width: 80.88,
    height: 79.33,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.666428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.05,
    y: 497.315,
    fontFamily: "Arial"
  }, "\n        Halifax_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.61,
    y: 536.98,
    width: 80.88,
    height: 80.48,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.748571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.05,
    y: 577.22,
    fontFamily: "Arial"
  }, "\n        Grayson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.61,
    y: 617.46,
    width: 80.88,
    height: 82.54,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.777142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 238.05,
    y: 658.73,
    fontFamily: "Arial"
  }, "\n        Norfolk_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.49,
    y: 221.89,
    width: 83.22,
    height: 82.09,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.863571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 320.1,
    y: 262.935,
    fontFamily: "Arial"
  }, "\n        Fairfax_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.71,
    y: 221.89,
    width: 83.83,
    height: 82.09,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.472666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 403.625,
    y: 262.935,
    fontFamily: "Arial"
  }, "\n        Alexandria_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445.54,
    y: 221.89,
    width: 84.07,
    height: 82.09,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.840833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 487.57500000000005,
    y: 262.935,
    fontFamily: "Arial"
  }, "\n        Smyth_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 529.6,
    y: 221.89,
    width: 84.89,
    height: 82.09,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.863571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 572.0450000000001,
    y: 262.935,
    fontFamily: "Arial"
  }, "\n        Augusta_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 614.49,
    y: 221.89,
    width: 85.51,
    height: 82.09,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.863571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 657.245,
    y: 262.935,
    fontFamily: "Arial"
  }, "\n        Roanoke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.49,
    y: 303.98,
    width: 96.67,
    height: 73.22,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.307058823529411
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.825,
    y: 340.59000000000003,
    fontFamily: "Arial"
  }, "\n        Newport_News_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.49,
    y: 377.2,
    width: 96.67,
    height: 78.71,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.825,
    y: 416.555,
    fontFamily: "Arial"
  }, "\n        Washington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.49,
    y: 455.91,
    width: 96.67,
    height: 79.46,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.675714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.825,
    y: 495.64000000000004,
    fontFamily: "Arial"
  }, "\n        Russell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.49,
    y: 535.38,
    width: 96.67,
    height: 81.01,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.400666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.825,
    y: 575.885,
    fontFamily: "Arial"
  }, "\n        Tazewell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.49,
    y: 616.39,
    width: 96.67,
    height: 83.61,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.361
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.825,
    y: 658.1949999999999,
    fontFamily: "Arial"
  }, "\n        Lee_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.16,
    y: 303.98,
    width: 78.01,
    height: 104.06,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5721428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 414.165,
    y: 356.01,
    fontFamily: "Arial"
  }, "\n        Lynchburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.17,
    y: 303.98,
    width: 80.71,
    height: 104.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.747647058823529
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.52500000000003,
    y: 356.01,
    fontFamily: "Arial"
  }, "\n        Rockingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.88,
    y: 303.98,
    width: 82.45,
    height: 104.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.8500000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.105,
    y: 356.01,
    fontFamily: "Arial"
  }, "\n        Shenandoah_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 616.33,
    y: 303.98,
    width: 83.67,
    height: 104.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.578
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 658.1650000000001,
    y: 356.01,
    fontFamily: "Arial"
  }, "\n        Portsmouth_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.16,
    y: 408.04,
    width: 132.48,
    height: 77.39,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.836875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.40000000000003,
    y: 446.735,
    fontFamily: "Arial"
  }, "\n        Arlington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.16,
    y: 485.43,
    width: 132.48,
    height: 96.14,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.40000000000003,
    y: 533.5,
    fontFamily: "Arial"
  }, "\n        Wise_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.16,
    y: 581.57,
    width: 132.48,
    height: 118.43,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.869166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.40000000000003,
    y: 640.7850000000001,
    fontFamily: "Arial"
  }, "\n        Roanoke_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.64,
    y: 408.04,
    width: 192.36,
    height: 115.14,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.8199999999999,
    y: 465.61,
    fontFamily: "Arial"
  }, "\n        Norfolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.64,
    y: 523.18,
    width: 192.36,
    height: 176.82,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.60153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.8199999999999,
    y: 611.5899999999999,
    fontFamily: "Arial"
  }, "\n        Richmond_City\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1932);
export default __webpack_public_path__ + "static/media/1932.0e539c4878843fa28938ebd046f62736.svg";
export { ForwardRef as ReactComponent };